import { TGetEstimationRealtorFormResponse } from '../../repositories/price-estimator/v1/get-estimation-realtor-form';
import { IEstimation } from '../../types/estimation/types';
import { DEFAULT_DESCRIPTION, DEFAULT_TITLE } from '../../constants/estimation';

export const prepareEstimation = (response: TGetEstimationRealtorFormResponse): IEstimation | null => {
  if (response.statusCode !== 200) {
    return null;
  }

  return {
    title: response.response.title || DEFAULT_TITLE,
    description: response.response.description || DEFAULT_DESCRIPTION,
    priceText: response.response.priceText as string,
    priceRangeText: response.response.priceRangeText as string,
  };
};
